/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
// import { setCurrentUser } from "../store/actions/authActions.js";
import { initFlowbite } from "flowbite";
import { NavLink } from "react-router-dom";
import { usePostHog } from '@posthog/react';
import TableSearchBar from "../../components/TableSearchBar";
import instance, { fetchRatingDueDate } from "../../api/api";
import { Loader } from "../../components/Loader";
import PerspectiveBadge from "../../components/PerspectiveBadge";
import GetScoreColor from "../../utils/GetScoreColor";
import { useTenant } from "../../context/Tenant/TenantContext";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
// import { sources } from "../../constants/sources";

type Risk = {
  id: string;
  riskNumber: string;
  perspective: string;
  objective: string;
  riskName: string;
  source: string;
  description: string;
  rootCause: string;
  descriptionScore: number;
  rootCauseScore: number;
};

function RiskScoring() {
  const posthog = usePostHog();
  const { config, loading: tenantLoading } = useTenant();
  const [isLoadingRisks, setIsLoadingRisks] = useState(false);
  // const [allRisks, setAllRisks] = useState([]);
  // const [allRiskScores, setAllRiskScores] = useState([]);
  const [allRiskWithScores, setAllRisksWithScores] = useState([]);
  const [currentRiskDetails, setCurrentRiskDetails] = useState<any>([]);
  const [riskScores, setRiskScores] = useState<[string, string][]>([]);

  const [isScoreDrawerOpen, setIsScoreDrawerOpen] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const closeScoreRiskDrawerButtonRef = useRef<any>(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [searchTerm, setSearchTerm] = useState("");

  const department = localStorage.getItem("department");

  const scoreDrawerRef = useRef<any>(null);

  // const [dueDate, setDueDate] = useState<any>(null);
  const [pageError, setPageError] = useState<any>(null);
  const [isRatingLocked, setIsRatingLocked] = useState(false);
  const [highlightedRiskId, setHighlightedRiskId] = useState<any>(null);
  const today = new Date();

  useEffect(() => {
    if (config?.Acceptance) setRiskScores(Object.entries(config.Acceptance));
  }, []);

  useEffect(() => {
    if (pageError) {
      const timer = setTimeout(() => {
        setPageError("");
      }, 5000); // Close the toast after 5 seconds

      return () => clearTimeout(timer);
    }
  }, [pageError]);

  const getAllRisks = async () => {
      try {
        setIsLoadingRisks(true);
        const response = await instance.get(
          "/api/employee/riskRegister/ASSESSMENT_IN_PROGRESS"
        );
        const scoresResponse = await instance.get(
          "/api/employee/riskRegister/scores/ASSESSMENT_IN_PROGRESS"
        );

        // setAllRisksWithScores(response.data.data);
        const riskRegister = response.data.data;
        const riskScores = scoresResponse.data.data;

        const combinedRisks = riskRegister.map((risk: any) => {
          const score = riskScores.find(
            (score: any) => score.riskRegisterId === risk.id
          );

          return {
            ...risk,
            descriptionSuggestion:
              risk.RiskRegisterUserScore &&
              risk.RiskRegisterUserScore.length > 0
                ? risk.RiskRegisterUserScore[0].descriptionSuggestion
                : "",
            rootCauseSuggestion:
              risk.RiskRegisterUserScore &&
              risk.RiskRegisterUserScore.length > 0
                ? risk.RiskRegisterUserScore[0].rootCauseSuggestion
                : "",          
            descriptionScore: score ? score._avg.descriptionScore : 0,
            rootCauseScore: score ? score._avg.rootCauseScore : 0,
          };
        });

        setAllRisksWithScores(combinedRisks);
        setIsLoadingRisks(false);
        initFlowbite();
        // setAllRisks(response.data.data);
      } catch (error) {
        setIsLoadingRisks(false);
        console.error(error);
      }
    };
  useEffect(() => {
    const fetchDueDate = async () => {
      const theDueDate = await fetchRatingDueDate();
      // setDueDate(FormatDueDates(theDueDate));
      if (theDueDate && theDueDate < today) {
        // setIsRatingLocked(true);
        setIsRatingLocked(false);
      } else {
        setIsRatingLocked(false);
      }
    };

    fetchDueDate();

    getAllRisks();
    posthog.capture('page_viewed', { page: 'employee_risk_scoring' });
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        scoreDrawerRef.current &&
        !scoreDrawerRef.current.contains(event.target)
      ) {
        setIsScoreDrawerOpen(false);
        setHighlightedRiskId(null);
      }
    };

    if (isScoreDrawerOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      setHighlightedRiskId(null);
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isScoreDrawerOpen]);

  const handleScoreRiskClick = async (riskId: string) => {
    const risk = allRiskWithScores.find((risk: Risk) => risk.id === riskId);
    setIsScoreDrawerOpen(true);
    setCurrentRiskDetails(risk);
    setHighlightedRiskId(riskId);
  };

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const handleScoreRisk = async (e:any) => {
    e.preventDefault();
    setIsSubmitting(true);
    const scoreDetails = { 
      descriptionScore: Number(currentRiskDetails.descriptionScore),
      descriptionSuggestion: currentRiskDetails.descriptionSuggestion,
      rootCauseScore: Number(currentRiskDetails.rootCauseScore),
      rootCauseSuggestion: currentRiskDetails.rootCauseSuggestion,
    };
    try {
      await instance.post(
        `/api/employee/riskRegister/score/create/${currentRiskDetails.id}`,
        scoreDetails
      );
      posthog.capture('employee_risk_scored', {
        riskId: currentRiskDetails.id,
        descriptionScore: scoreDetails.descriptionScore,
        rootCauseScore: scoreDetails.rootCauseScore,
      });
      setIsSubmitting(false);
      await getAllRisks();
    } catch (error: any) {
      posthog.capture('employee_risk_score_failed', { riskId: currentRiskDetails.id, error: error.response?.data?.message });
      setPageError(error.response.data.message);
      setIsSubmitting(false);
      return error;
    }
  };

  // Calculate the items to display based on the current page and items per page
  const paginatedRisks = React.useMemo(() => {
    let risksToDisplay = allRiskWithScores;

    // Apply search filter
    if (searchTerm) {
      risksToDisplay = risksToDisplay.filter((risk: any) =>
        Object.values(risk).some((value) =>
          String(value).toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return risksToDisplay.slice(indexOfFirstItem, indexOfLastItem);
  }, [allRiskWithScores, currentPage, itemsPerPage, searchTerm]);

  const totalPages = Math.ceil(allRiskWithScores.length / itemsPerPage);

  const columnHelper = createColumnHelper<Risk>();
  const columns = [
    columnHelper.accessor("riskNumber", {
      header: () => <span className="whitespace-nowrap">Risk Number</span>,
      cell: (info) => (
        <span className="whitespace-nowrap font-bold">{info.getValue()}</span>
      ),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor((row) => row.perspective, {
      id: "perspective",
      cell: (info) => <PerspectiveBadge value={info.getValue()} />,
      header: () => <span>Perspective</span>,
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("objective", {
      header: () => "Objective",
      cell: (info) => info.renderValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("riskName", {
      header: () => <span>Risk Name</span>,
      cell: (info) => info.renderValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("source", {
      header: "Source",
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor("description", {
      header: "Description",
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor("rootCause", {
      header: () => "Root Cause",
      cell: (info) => info.getValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.display({
      id: "actions",
      header: () => <span>Actions</span>,
      cell: ({ row }) => (
        <button
          type="button"
          className={`w-auto flex justify-center items-center text-caribbeanCurrent hover:text-white border border-caribbeanCurrent hover:bg-caribbeanCurrent focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-xs px-4 py-2 text-center inline-flex me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-caribbeanCurrent dark:focus:ring-blue-800 ${
            isRatingLocked
              ? "bg-gray-400 cursor-not-allowed text-white border-none hover:bg-gray-400"
              : "hover:bg-blue-800 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          }`}
          disabled={isRatingLocked}
          data-drawer-target="drawer-score-risk"
          data-drawer-show="drawer-score-risk"
          data-drawer-placement="right"
          aria-controls="drawer-score-risk"
          onClick={() => {
            setIsScoreDrawerOpen(true);
            handleScoreRiskClick(row.original.id);
          }}
        >
          <svg
            className="w-4 h-4 text-white-800 dark:text-white me-2"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
            />
          </svg>
          Comment
        </button>
      ),
    }),
  ];

  const table = useReactTable<Risk>({
    data: paginatedRisks,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  if (tenantLoading || !config) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader size="xl" />
      </div>
    );
  }

  return (
    <>
      {/* <!-- Breadcrumb --> */}
      <nav
        className="justify-between  py-3 text-gray-700  sm:flex bg-gray-50"
        aria-label="Breadcrumb"
      >
        <ol className="inline-flex items-center mb-3 space-x-1 md:space-x-2 rtl:space-x-reverse sm:mb-0">
          <li>
            <div className="flex items-center">
              <NavLink
                to=""
                className=" text-sm font-medium text-gray-700 hover:text-blue-600  dark:text-gray-400 dark:hover:text-white"
              >
                Risk Registration
              </NavLink>
            </div>
          </li>

          <li aria-current="page">
            <div className="flex items-center ">
              <svg
                className="rtl:rotate-180 w-3 h-3 mx-1 text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 6 10"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 9 4-4-4-4"
                />
              </svg>
              <span className="mx-1 text-sm font-medium text-gray-500 md:mx-2 dark:text-gray-400">
                Comment
              </span>
            </div>
          </li>
        </ol>
      </nav>
      <h1 className="text-xl mb-3 font-semibold text-gray-700">Invite Comments</h1>

      {/* <p className="text-caribbeanCurrent font-semibold">Due date: {dueDate}</p> */}
      <form className="flex max-w-sm my-4 justify-center items-center">
        <label
          htmlFor="countries"
          className="block mb-2 text-md font-medium text-gray-900 dark:text-white"
        >
          Department
        </label>
        <span className="ml-5 bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
          {department}
        </span>
      </form>

      <div className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600 mb-4">
        <div className="rt-wrap relative overflow-x-auto sm:rounded-lg">
          <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <caption className="p-5 text-lg font-semibold text-left rtl:text-right text-gray-900 bg-white dark:text-white dark:bg-gray-800">
              <div className="w-full flex  items-center justify-between">
                <p>Department Risks</p>
                <div className="flex flex-row gap-4 items-center justify-center">
                  <div className="">
                    <TableSearchBar
                      searchTerm={searchTerm}
                      onSearchChange={setSearchTerm}
                      placeholder="Search risks..."
                    />
                  </div>
                </div>
              </div>
            </caption>
            <thead className="text-sm text-jet font-bold bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => (
                    <th scope="col" className="px-6 py-3" key={header.id}>
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            {isLoadingRisks ? (
              <tbody>
                <tr className="text-center">
                  <td colSpan={7} className="text-center">
                    <div className="flex justify-center items-center h-96">
                      <Loader size={"xl"} />
                    </div>
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody className="text-jet font-medium text-xs">
                {table.getRowModel().rows.map((row) => (
                  <>
                  <tr
                    key={row.id}
                    className={`bg-gray hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 ${
                      highlightedRiskId === row.original.id ? "bg-gray-200" : ""
                    }`}
                  >
                    {row.getVisibleCells().map((cell) => (
                      <td className="px-6 py-4 align-top" key={cell.id}>
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    ))}
                  </tr>
<tr className="bg-transparent">
                      {row.getVisibleCells().map((cell) => (
                        <td
                          className="px-6 py-2 border-b text-gray-500 text-xs bg-transparent"
                          key={`${cell.id}-score`}
                        >
                          {cell.column.id === "description" && (
                            <div className="font-bold text-gray-500">
                              Comment:{" "}
                              <span
                                className={GetScoreColor(
                                  row.original.descriptionScore
                                )}
                              >
                                {row.original.descriptionScore}
                              </span>
                            </div>
                          )}
                          {cell.column.id === "rootCause" && (
                            <div className="font-bold text-gray-500">
                              Comment:{" "}
                              <span
                                className={GetScoreColor(
                                  row.original.rootCauseScore
                                )}
                              >
                                {row.original.rootCauseScore}
                              </span>
                            </div>
                          )}
                        </td>
                      ))}
                    </tr>
                  </>
                ))}
              </tbody>
            )}
          </table>

          {/* Pagination */}
          <div className="mt-4 pl-10 pr-10 pb-5 text-jet font-medium text-xs ">
            <nav aria-label="Page navigation">
              <ul className="flex justify-between">
                <li className="flex flex-row items-center">
                  <div>
                    <p>Show rows per page</p>
                  </div>
                  <div>
                    <select
                      className="ml-2 bg-gray-50 border border-caribbeanCurrent text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      onChange={(e) => setItemsPerPage(Number(e.target.value))}
                    >
                      <option>25</option>
                      <option>50</option>
                      <option>100</option>
                    </select>
                  </div>
                </li>
                <li className="flex flex-row gap-1 items-center text-gray-500">
                  <div>
                    <p>
                      {currentPage} of {totalPages === 0 ? 1 : totalPages}
                    </p>
                  </div>
                  <div>
                    <button
                      className="px-3 py-2 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg rounded-r-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      {"<"}
                    </button>
                  </div>
                  <div>
                    <button
                      className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg rounded-l-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      {">"}
                    </button>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      {/* drawers */}

      {/* score risk */}
      {allRiskWithScores.length > 0 && (
        <div
          id="drawer-score-risk"
          ref={scoreDrawerRef}
          className={`fixed top-0 right-0 z-40 h-screen p-4 overflow-y-auto transition-transform ${
            isScoreDrawerOpen ? "translate-x-0" : "translate-x-full"
          } bg-white w-full md:w-1/4 dark:bg-gray-800`}
          tabIndex={-1}
          aria-labelledby="drawer-score-risk-label"
        >
          <h5
            id="drawer-label"
            className="inline-flex items-center mb-6 text-base font-semibold text-gray-500  dark:text-gray-400"
          >
            Invite Comments
          </h5>
          <p className="text-sm my-4 text-gray-400">
            You are about to review a risk, please keep it professional
          </p>
          <button
            type="button"
            data-drawer-hide="drawer-score-risk"
            aria-controls="drawer-score-risk"
            className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute top-2.5 end-2.5 inline-flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white"
            ref={closeScoreRiskDrawerButtonRef}
            onClick={() => setIsScoreDrawerOpen(false)}
          >
            <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span className="sr-only">Close menu</span>
          </button>
          {/* <div className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600  mb-4 p-4">
            <div className="mb-6">
              <label
                htmlFor="riskName"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Name
              </label>
              <input
                type="text"
                id="riskName"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Risk title goes here"
                required
                disabled
                readOnly
                defaultValue={currentRiskDetails.riskName}
              />
            </div>

          </div> */}
          {/* <div className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600  mb-4 p-4">
            <div className="mb-6">
              <label
                htmlFor="riskSource"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Source
              </label>
              <input
                type="text"
                id="riskName"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Risk source goes here"
                required
                disabled
                readOnly
                defaultValue={currentRiskDetails.source}
              />
            </div>

            <div className="mb-6">
              <label
                htmlFor="riskGoals"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Select Your Score
              </label>
              <select
                id="riskGoals"
                className=" bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                onChange={(e) => {
                  setCurrentRiskDetails((prevState) => ({
                    ...prevState,
                    sourceScore: e.target.value,
                  }));
                }}
              >
                <option>Select Score</option>
                {riskScores.map(([score, name]) => (
                  <option value={score} key={score}>
                    {score} {name}
                  </option>
                ))}
              </select>
            </div>
            {currentRiskDetails.sourceScore > 0 &&
              currentRiskDetails.sourceScore <= 2 && (
                <div className="mb-6">
                  <label
                    htmlFor="sourceSuggestion"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Risk Source
                  </label>
                  <select
                    id="sourceSuggestion"
                    className=" bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    onChange={(e) => {
                      setCurrentRiskDetails((prevState) => ({
                        ...prevState,
                        sourceSuggestion: e.target.value,
                      }));
                    }}
                  >
                    {sources.map((source, index) => (
                      <option key={index}>{source}</option>
                    ))}
                  </select>
                </div>
              )}
          </div> */}
          <div className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600  mb-4 p-4">
            <div className="mb-6">
              <label
                htmlFor="riskDescription"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Description
              </label>
              <textarea
                id="riskDescription"
                rows={4}
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Description goes here..."
                disabled
                readOnly
                defaultValue={currentRiskDetails.description}
              ></textarea>
            </div>

            <div className="mb-6">
              <label
                htmlFor="riskGoals"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Select A Comment
              </label>
              <select
                id="riskGoals"
                className=" bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                onChange={(e) => {
                  setCurrentRiskDetails((prevState: any) => ({
                    ...prevState,
                    descriptionScore: e.target.value,
                  }));
                }}
              >
                <option>Select Comment</option>
                {riskScores.map(([score, name]) => (
                  <option value={score} key={score}>
                    {score} {name}
                  </option>
                ))}
              </select>
            </div>
            {currentRiskDetails.descriptionScore > 0 &&
              currentRiskDetails.descriptionScore <= 2 && (
                <div className="mb-6">
                  <label
                    htmlFor="descriptionSuggestion"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Suggestion
                  </label>
                  <textarea
                    id="descriptionSuggestion"
                    rows={4}
                    className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Suggestion goes here..."
                    onChange={(e) => {
                      setCurrentRiskDetails((prevState: any) => ({
                        ...prevState,
                        descriptionSuggestion: e.target.value,
                      }));
                    }}
                    value={currentRiskDetails.descriptionSuggestion}
                  ></textarea>
                </div>
              )}
          </div>

          <div className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600  mb-4 p-4">
            <div className="mb-6">
              <label
                htmlFor="riskCause"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Root Cause
              </label>
              <textarea
                id="riskCause"
                rows={4}
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Root cause goes here..."
                disabled
                readOnly
                defaultValue={currentRiskDetails.rootCause}
              ></textarea>
            </div>

            <div className="mb-6">
              <label
                htmlFor="riskGoals"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Select A Comment
              </label>
              <select
                id="rootCause"
                className=" bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                onChange={(e) => {
                  setCurrentRiskDetails((prevState: any) => ({
                    ...prevState,
                    rootCauseScore: e.target.value,
                  }));
                }}
              >
                <option>Select Comment</option>
                {riskScores.map(([score, name]) => (
                  <option value={score} key={score}>
                    {score} {name}
                  </option>
                ))}
              </select>
            </div>
            {currentRiskDetails.rootCauseScore > 0 &&
              currentRiskDetails.rootCauseScore <= 2 && (
                <div className="mb-6">
                  <label
                    htmlFor="rootCauseSuggestion"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Suggestion
                  </label>
                  <textarea
                    id="rootCauseSuggestion"
                    rows={4}
                    className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Root cause suggestion here"
                    onChange={(e) => {
                      setCurrentRiskDetails((prevState: any) => ({
                        ...prevState,
                        rootCauseSuggestion: e.target.value,
                      }));
                    }}
                    value={currentRiskDetails.rootCauseSuggestion}
                  ></textarea>
                </div>
              )}
          </div>
          {pageError && <p className="text-red text-sm mb-4">{pageError}!</p>}
          <button
            type="submit"
            className="justify-center items-center inline-flex text-white bg-caribbeanCurrent hover:bg-blue-800 w-full focus:ring-4 focus:ring-caribbeanCurrent font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-caribbeanCurrent dark:hover:bg-caribbeanCurrent focus:outline-none dark:focus:ring-caribbeanCurrent block"
            onClick={handleScoreRisk}
          >
            <svg
              className="w-4 h-4 text-white-800 dark:text-white mr-2"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                strokeWidth="2"
                d="M11.083 5.104c.35-.8 1.485-.8 1.834 0l1.752 4.022a1 1 0 0 0 .84.597l4.463.342c.9.069 1.255 1.2.556 1.771l-3.33 2.723a1 1 0 0 0-.337 1.016l1.03 4.119c.214.858-.71 1.552-1.474 1.106l-3.913-2.281a1 1 0 0 0-1.008 0L7.583 20.8c-.764.446-1.688-.248-1.474-1.106l1.03-4.119A1 1 0 0 0 6.8 14.56l-3.33-2.723c-.698-.571-.342-1.702.557-1.771l4.462-.342a1 1 0 0 0 .84-.597l1.753-4.022Z"
              />
            </svg>
            {isSubmitting ? <Loader size={"sm"} /> : "Submit Scores"}
          </button>
        </div>
      )}
    </>
  );
}

export default connect()(RiskScoring);
